export default __webpack_public_path__ + "static/logo-star-radler-dbeafd0f2577a1aeab2261945c0b1b45.png";